import { render, staticRenderFns } from "./Month.vue?vue&type=template&id=20c0b439&scoped=true"
import script from "./Month.vue?vue&type=script&lang=js"
export * from "./Month.vue?vue&type=script&lang=js"
import style0 from "./Month.vue?vue&type=style&index=0&id=20c0b439&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c0b439",
  null
  
)

export default component.exports